import React, { useEffect, useState } from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import DepartmentSectionStyle2 from '../Section/DepartmentSection/DepartmentSectionStyle2';
import TeamSection from '../Section/TeamSection';
import GallerySection from '../Section/GallerySection';
import SectionHeading from '../SectionHeading';
import { pageTitle } from '../../helpers/PageTitle';
import { getGallery } from '../../helpers/lib/axios';

const departmentData = [
  {
    title: 'Psychotherapy',
    iconUrl: '/images/icons/professional.svg',
    href: '/services',
  },
  {
    title: 'Training and Consultation',
    iconUrl: '/images/icons/experience.svg',
    href: '/services',
  },
  {
    title: 'Workshops, Webinars & Seminars',
    iconUrl: '/images/icons/schedule.svg',
    href: '/services',
  },
  {
    title: 'Corporate Social Responsibility (CSR)',
    iconUrl: '/images/icons/comprehensive.svg',
    href: '/services',
  },
];

const teamData = [
  {
    imgUrl: 'images/about/coo.webp',
    name: 'Peace Olawale',
    designation: 'Clinical Psychologist',
  },
  {
    imgUrl: 'images/about/cmo.webp',
    name: 'Deborah Alifa',
    designation: 'Marketing Lead',
  },
  {
    imgUrl: 'images/about/cfo.webp',
    name: 'Joy Olawale',
    designation: 'Finance Lead',
  },
];

export default function About() {
  pageTitle('About');
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getGallery().then(gal => {
      setGallery(Array.isArray(gal?.data) ? gal.data : []);
    }).catch(() => {
      setGallery([]);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-cream min-h-screen">
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.svg"
        imgUrl="/images/new/Mental health icon 11 Alterego.png"
        title="Welcome to <br />Noohra Nigeria"
        subTitle="We are committed to promoting mental health awareness and well-being through psychoeducation via seminars, webinars, workshops, and offering personalized therapy sessions."
      />

      {/* Services Section */}
      <div className="py-16 md:py-24">
        <DepartmentSectionStyle2
          sectionTitle="What We Do"
          sectionTitleUp="SERVICES"
          data={departmentData}
        />
      </div>

      {/* Mission & Vision Section (Rewritten with Tailwind) */}
      <section className="py-16 md:py-24 bg-cream-dark border-y border-[rgba(139,26,26,0.08)]">
        <div className="max-w-[1200px] mx-auto px-6 md:px-16">
          <SectionHeading title="Our Mission and Vision" center />
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 mt-10 md:mt-16 max-w-[900px] mx-auto">
            {/* Vision Card */}
            <div className="bg-white p-8 md:p-12 rounded-lg shadow-sm border border-cream transition-all duration-300 hover:shadow-md hover:-translate-y-1 group">
              <div className="w-14 h-14 bg-cream-dark rounded-full flex items-center justify-center mb-6 md:mb-8 border border-[rgba(139,26,26,0.1)] group-hover:bg-crimson group-hover:border-crimson transition-colors duration-300">
                <img src="/images/icons/professional.svg" alt="Vision" className="w-7 h-7 object-contain opacity-70 group-hover:brightness-0 group-hover:invert transition-all duration-300" />
              </div>
              <h3 className="font-serif text-3xl text-charcoal mb-4">Vision</h3>
              <p className="text-base text-mid font-light leading-relaxed m-0">
                To foster psychological harmony and well-being, empowering individuals and communities to thrive.
              </p>
            </div>

            {/* Mission Card */}
            <div className="bg-white p-8 md:p-12 rounded-lg shadow-sm border border-cream transition-all duration-300 hover:shadow-md hover:-translate-y-1 group">
              <div className="w-14 h-14 bg-cream-dark rounded-full flex items-center justify-center mb-6 md:mb-8 border border-[rgba(139,26,26,0.1)] group-hover:bg-crimson group-hover:border-crimson transition-colors duration-300">
                <img src="/images/icons/comprehensive.svg" alt="Mission" className="w-7 h-7 object-contain opacity-70 group-hover:brightness-0 group-hover:invert transition-all duration-300" />
              </div>
              <h3 className="font-serif text-3xl text-charcoal mb-4">Mission</h3>
              <p className="text-base text-mid font-light leading-relaxed m-0">
                To identify and support individuals in need of psychological assistance by providing customized psychotherapeutic interventions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <div className="py-16 md:py-24">
        <TeamSection
          sectionTitle="Team Members"
          sectionTitleUp="MEET OUR"
          data={teamData}
        />
      </div>

      {/* Gallery Section */}
      <div className="pb-16 md:pb-24">
        {loading ? (
          <p className="flex justify-center items-center text-center font-medium italic text-mid">Loading Activities...</p>
        ) : (
          <GallerySection
            sectionTitle="Our Latest <br />Activities"
            sectionTitleUp="HAVE A LOOK AT"
            data={gallery}
          />
        )}
      </div>

      {/* Bottom CTA Banner */}
      <BannerSectionStyle4
        bgUrl="images/about/banner.png"
        title="Join us on this journey as we work together to build a brighter future for your mental well-being!"
        subTitle="“Noohra” is an Aramaic word that means “light”, and so we are committed to bringing light into a dark world by promoting mental health awareness and intervention."
        center
      />
    </div>
  );
}
